<bn-chart
  [chartSummaryLabels]="chartSummaryLabels"
  [chartType]="chartTypes.Line"
  [dataGranularity]="dataGranularity()"
  [isLoading]="isLoading"
  [options]="chartOptions"
  [timeframe]="timeframe" />
